export const getEnumValues = <T extends Record<string, unknown>>(enumObject: T) => Object
  .keys(enumObject)
  .filter((key) => Number.isNaN(Number(key)))

  .map((key) => enumObject[key] as T[keyof T]);
